"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PersonalInfo_1 = require("./PersonalInfo");
exports.default = PersonalInfo_1.PersonalInfo;
